import React from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { process } from "@progress/kendo-data-query";

export default class RegistrationHistoryGrid extends React.Component {
  constructor(props) {
    super(props);
    this._export = null;
    this.state = {
      dataState: {
        skip: 0,
        take: 20,
        sort: [{ field: "dateSubmitted", dir: "desc" }]
      },
      filters: {
        salesRep: null,
        status: null,
        search: "",
        startDate: null,
        endDate: null
      }
    };
  }

  onDataStateChange = (e) => {
    this.setState({ dataState: e.dataState });
  };

  getFilteredData = () => {
    var data = this.props.data || [];
    var f = this.state.filters;

    if (f.salesRep) {
      data = data.filter(d => d.salesRepNo === f.salesRep);
    }
    if (f.status) {
      data = data.filter(d => d.status === f.status);
    }
    if (f.search) {
      var q = f.search.toLowerCase();
      data = data.filter(d =>
        (d.companyName || "").toLowerCase().indexOf(q) > -1 ||
        (d.email || "").toLowerCase().indexOf(q) > -1 ||
        (d.firstName || "").toLowerCase().indexOf(q) > -1 ||
        (d.lastName || "").toLowerCase().indexOf(q) > -1
      );
    }
    if (f.startDate && f.endDate) {
      var start = f.startDate;
      var end = f.endDate;
      data = data.filter(d => {
        if (!d.dateSubmitted) return false;
        var parts = d.dateSubmitted.split("/");
        var dt = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
        return dt >= start && dt <= end;
      });
    }
    return data;
  };

  onFilterChange = (field, value) => {
    this.setState(prev => ({
      filters: { ...prev.filters, [field]: value },
      dataState: { ...prev.dataState, skip: 0 }
    }));
  };

  onRefresh = () => {
    this.setState({
      dataState: {
        skip: 0,
        take: 20,
        sort: [{ field: "dateSubmitted", dir: "desc" }]
      },
      filters: {
        salesRep: null,
        status: null,
        search: "",
        startDate: null,
        endDate: null
      }
    });
  };

  onExportExcel = () => {
    if (this._export) {
      var data = this.getFilteredData();
      this._export.save(data);
    }
  };

  render() {
    var opts = this.props.filterOptions || {};
    var role = opts.role || "SalesRep";
    var salesReps = opts.salesReps || [];
    var showSalesRep = role === "Administrator";

    var f = this.state.filters;
    var filteredData = this.getFilteredData();
    var result = process(filteredData, this.state.dataState);

    var defaultDropItem = { value: null, text: "All" };
    var statusOptions = [
      { value: null, text: "All" },
      { value: "Pending", text: "Pending" },
      { value: "Approved", text: "Approved" },
      { value: "Rejected", text: "Rejected" }
    ];

    return (
      <div>
        <div className="quote-history-filters">
          {showSalesRep && (
            <div className="quote-filter-item">
              <label>Sales Rep</label>
              <DropDownList
                data={[defaultDropItem, ...salesReps]}
                textField="text"
                dataItemKey="value"
                value={salesReps.find(s => s.value === f.salesRep) || defaultDropItem}
                onChange={(e) => this.onFilterChange("salesRep", e.target.value.value)}
                style={{ width: "200px" }}
              />
            </div>
          )}
          <div className="quote-filter-item">
            <label>Status</label>
            <DropDownList
              data={statusOptions}
              textField="text"
              dataItemKey="value"
              value={statusOptions.find(s => s.value === f.status) || statusOptions[0]}
              onChange={(e) => this.onFilterChange("status", e.target.value.value)}
              style={{ width: "140px" }}
            />
          </div>
          <div className="quote-filter-item">
            <label>Search</label>
            <input
              type="text"
              className="k-input k-textbox k-input-md k-rounded-md k-input-solid"
              value={f.search}
              onChange={(e) => this.onFilterChange("search", e.target.value)}
              placeholder="Name, Email, Company..."
              style={{ width: "200px" }}
            />
          </div>
          <div className="quote-filter-item">
            <label>Start Date</label>
            <DatePicker
              value={f.startDate}
              onChange={(e) => this.onFilterChange("startDate", e.value)}
              format="MM/dd/yyyy"
              style={{ width: "160px" }}
            />
          </div>
          <div className="quote-filter-item">
            <label>End Date</label>
            <DatePicker
              value={f.endDate}
              onChange={(e) => this.onFilterChange("endDate", e.value)}
              format="MM/dd/yyyy"
              style={{ width: "160px" }}
            />
          </div>
        </div>

        <ExcelExport
          data={filteredData}
          fileName="RegistrationHistory.xlsx"
          ref={(exporter) => { this._export = exporter; }}
        >
          <Grid
            data={result}
            {...this.state.dataState}
            onDataStateChange={this.onDataStateChange}
            sortable={true}
            pageable={{ pageSizes: [10, 20, 50] }}
            style={{ fontSize: "14px" }}
            cellRender={(cell, cellProps) => {
              if (!cell || !cell.props) return cell;
              const labels = { companyName: "Company", name: "Name", email: "Email", customerType: "Type", industryType: "Industry", dateSubmitted: "Date Submitted", status: "Status", salesRepNo: "Sales Rep" };
              const label = labels[cellProps.field] || "";
              return React.cloneElement(cell, { ...cell.props, "data-label": label });
            }}
          >
            <GridToolbar>
              <button className="k-button k-button-md k-rounded-md k-button-solid" style={{ backgroundColor: "#333", color: "#fff", borderColor: "#333" }} onClick={this.onExportExcel}>
                <span className="k-icon k-i-file-excel"></span>&nbsp;Export to Excel
              </button>
              <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={this.onRefresh} style={{ marginLeft: "auto" }}>
                <span className="k-icon k-i-reload"></span>&nbsp;Refresh Grid
              </button>
            </GridToolbar>
            <GridColumn
              field="companyName"
              title="Company"
              cell={(props) => (
                <td data-label="Company">
                  <a href={"/Registration/Detail/" + props.dataItem.id} style={{ textDecoration: "underline" }}>
                    {props.dataItem.companyName || "—"}
                  </a>
                </td>
              )}
            />
            <GridColumn field="name" title="Name" />
            <GridColumn field="email" title="Email" />
            <GridColumn field="industryType" title="Industry" width="120" />
            <GridColumn field="dateSubmitted" title="Date Submitted" width="130" />
            <GridColumn
              field="status"
              title="Status"
              width="180"
              cell={(props) => {
                var status = props.dataItem.status || "";
                var cls = "quote-detail-status " + status.toLowerCase();
                return <td data-label="Status"><span className={cls}>{status}</span></td>;
              }}
            />
            <GridColumn field="salesRepNo" title="Sales Rep" />
          </Grid>
        </ExcelExport>
      </div>
    );
  }
}
